module.exports = {
  id: 39,
  name: 'Sprint Intervals',
  categories: ['cardio', 'strength', 'legs', 'endurance'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Endurance',
  points: 26,
  instructions:
    'Sprint intervals are intense! Sprint in place meaning you are running in place but as fast as you can! This builds incredible speed and endurance!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to sprint like lightning? Let us build the explosiveness of your legs!',
    },
    {
      time: 3,
      text: 'Stand with feet shoulder-width apart, ready to sprint!',
    },
    {
      time: 6,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 9,
      text: 'Sprint in place! Drive your knees up high and pump your arms fast!',
    },
    // SPRINT 1 - 45 seconds
    {
      time: 12,
      text: 'Perfect sprint position! Feet shoulder-width apart, chest up!',
    },
    {
      time: 15,
      text: 'Start strong! Drive your knees up high like you are running up stairs!',
    },
    {
      time: 18,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 21,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 24,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 27,
      text: 'Breathe in and out, stay focused!',
    },
    {
      time: 30,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 33,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 36,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 39,
      text: 'Keep your form perfect, chest up! Higher knees, higher knees! Sprint faster in place!',
    },
    {
      time: 42,
      text: 'Build your speed, push harder! Keep your core engaged by tightening your stomach muscles!',
    },
    {
      time: 45,
      text: 'Pump your arms fast, higher knees, almost there!',
    },
    {
      time: 48,
      text: 'Stay on your toes, feet the power of your legs, finish strong!',
    },
    {
      time: 51,
      text: 'Great sprint! Now rest and recover!',
    },
    // REST 1 - 45 seconds
    {
      time: 54,
      text: 'Walk in place, shake out your legs and feet!',
    },
    {
      time: 57,
      text: 'Take deep breaths, in through nose, out through mouth!',
    },
    {
      time: 60,
      text: 'You are building incredible endurance!',
    },
    {
      time: 63,
      text: 'Shake out your arms and shoulders!',
    },
    {
      time: 66,
      text: 'Get ready for sprint 2, focus on your form!',
    },
    {
      time: 69,
      text: 'Remember to drive your knees up high and pump your arms!',
    },
    {
      time: 72,
      text: '3, 2, 1, START! Sprint in place! Drive your knees up high and pump your arms fast!',
    },
    // SPRINT 2 - 45 seconds
    {
      time: 75,
      text: "Way to go on having perfect sprint position! Feet shoulder-width apart, chest up, just like how you're doing it!",
    },
    {
      time: 78,
      text: 'Drive your knees up high like you are running up stairs! Keep your core engaged by tightening your stomach muscles!',
    },
    {
      time: 81,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 84,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 87,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 90,
      text: 'Breathe rhythmically, stay focused!',
    },
    {
      time: 93,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 96,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 99,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 102,
      text: 'Keep your form perfect, chest up!',
    },
    {
      time: 105,
      text: 'Build your speed, push harder!',
    },
    {
      time: 108,
      text: 'Pump your arms fast, almost there!',
    },
    {
      time: 111,
      text: 'Stay on your toes, finish strong!',
    },
    {
      time: 114,
      text: 'Great sprint! Now rest and recover!',
    },
    // REST 2 - 45 seconds
    {
      time: 117,
      text: 'Walk in place, shake out your legs and feet!',
    },
    {
      time: 120,
      text: 'Take deep breaths, in through nose, out through mouth!',
    },
    {
      time: 123,
      text: 'You are building incredible endurance!',
    },
    {
      time: 126,
      text: 'Shake out your arms and shoulders!',
    },
    {
      time: 129,
      text: 'Get ready for sprint 3, focus on your form!',
    },
    {
      time: 132,
      text: 'Remember to drive your knees up high and pump your arms!',
    },
    {
      time: 135,
      text: '3, 2, 1, START! Drive your knees up high and pump your arms fast!',
    },
    // SPRINT 3 - 45 seconds
    {
      time: 138,
      text: 'Perfect sprint position! Feet shoulder-width apart, chest up!',
    },
    {
      time: 141,
      text: 'Start strong! Drive your knees up high like you are running up stairs!',
    },
    {
      time: 144,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 147,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 150,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 153,
      text: 'Breathe rhythmically, stay focused!',
    },
    {
      time: 156,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 159,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 162,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 165,
      text: 'Keep your form perfect, chest up!',
    },
    {
      time: 168,
      text: 'Build your speed, push harder! Sprint it placee!',
    },
    {
      time: 171,
      text: 'Pump your arms fast, almost there!',
    },
    {
      time: 174,
      text: 'Stay on your toes, finish strong!',
    },
    {
      time: 177,
      text: 'Great sprint! Now rest and recover!',
    },
    // REST 3 - 45 seconds
    {
      time: 180,
      text: 'Walk in place, shake out your legs and feet!',
    },
    {
      time: 183,
      text: 'Take deep breaths, in through nose, out through mouth!',
    },
    {
      time: 186,
      text: 'You are building incredible endurance!',
    },
    {
      time: 189,
      text: 'Shake out your arms and shoulders!',
    },
    {
      time: 192,
      text: 'Get ready for sprint 4, focus on your form!',
    },
    {
      time: 195,
      text: 'Remember to drive your knees up high and pump your arms!',
    },
    {
      time: 198,
      text: '3, 2, 1, START! Sprint in place! Drive your knees up high and pump your arms fast!',
    },
    // SPRINT 4 - 45 seconds
    {
      time: 201,
      text: 'You got this! Focus on sprinting form, keep your core engaged by tightening your stomach muscles!',
    },
    {
      time: 204,
      text: "Stay strong, you're a true sprinter! Drive your knees up high like you are running up stairs!",
    },
    {
      time: 207,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 210,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 213,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 216,
      text: 'Breathe in and out, keep your focus! Sprint in place!',
    },
    {
      time: 219,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 222,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 225,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 228,
      text: 'Keep your form perfect, chest up!',
    },
    {
      time: 231,
      text: 'Build your speed, push harder!',
    },
    {
      time: 234,
      text: 'Pump your arms fast, almost there!',
    },
    {
      time: 237,
      text: 'Stay on your toes, finish strong!',
    },
    {
      time: 240,
      text: 'Great sprint! Now rest and recover!',
    },
    // REST 4 - 45 seconds
    {
      time: 243,
      text: 'Walk in place, shake out your legs and feet!',
    },
    {
      time: 246,
      text: 'Take deep breaths, in through nose, out through mouth!',
    },
    {
      time: 249,
      text: 'You are building incredible endurance!',
    },
    {
      time: 252,
      text: 'Shake out your arms and shoulders!',
    },
    {
      time: 255,
      text: 'Get ready for sprint 5, focus on your form!',
    },
    {
      time: 258,
      text: 'Remember to drive your knees up high and pump your arms!',
    },
    {
      time: 261,
      text: '3, 2, 1, START! Drive your knees up high and pump your arms fast!',
    },
    // SPRINT 5 - 45 seconds
    {
      time: 264,
      text: 'Perfect sprint position! Feet shoulder-width apart, chest up!',
    },
    {
      time: 267,
      text: 'Start strong! Drive your knees up high like you are running up stairs!',
    },
    {
      time: 270,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 273,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 276,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 279,
      text: 'Breathe rhythmically, stay focused!',
    },
    {
      time: 282,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 285,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 288,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 291,
      text: 'Keep your form perfect, chest up!',
    },
    {
      time: 294,
      text: 'Build your speed, push harder!',
    },
    {
      time: 297,
      text: 'Pump your arms fast, almost there!',
    },
    {
      time: 300,
      text: 'Stay on your toes, finish strong!',
    },
    {
      time: 303,
      text: 'Great sprint! Now rest and recover!',
    },
    // REST 5 - 45 seconds
    {
      time: 306,
      text: 'Walk in place, shake out your legs and feet!',
    },
    {
      time: 309,
      text: 'Take deep breaths, in through nose, out through mouth!',
    },
    {
      time: 312,
      text: 'You are building incredible endurance!',
    },
    {
      time: 315,
      text: 'Shake out your arms and shoulders!',
    },
    {
      time: 318,
      text: 'Get ready for the final sprint, focus on your form!',
    },
    {
      time: 321,
      text: 'Remember to drive your knees up high and pump your arms!',
    },
    {
      time: 324,
      text: '3, 2, 1, START! Give it everything you have!',
    },
    // SPRINT 6 - 45 seconds
    {
      time: 327,
      text: 'Perfect sprint position! Feet shoulder-width apart, chest up!',
    },
    {
      time: 330,
      text: 'Start strong! Drive your knees up high like you are running up stairs!',
    },
    {
      time: 333,
      text: 'Pump your arms from shoulder to hip, fast and controlled!',
    },
    {
      time: 336,
      text: 'Stay on the balls of your feet, stay light and quick!',
    },
    {
      time: 339,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 342,
      text: 'Breathe rhythmically, stay focused!',
    },
    {
      time: 345,
      text: 'Drive your knees up high, push harder!',
    },
    {
      time: 348,
      text: 'Pump your arms fast, you are doing great!',
    },
    {
      time: 351,
      text: 'Stay on your toes, stay light and explosive!',
    },
    {
      time: 354,
      text: 'Keep your form perfect, chest up!',
    },
    {
      time: 357,
      text: 'Build your speed, push harder!',
    },
    {
      time: 360,
      text: 'Pump your arms fast, almost there!',
    },
    {
      time: 363,
      text: 'Stay on your toes, finish strong!',
    },
    {
      time: 366,
      text: 'Incredible work! You just completed all six sprints!',
    },
    // COMPLETION
    {
      time: 369,
      text: 'Amazing work! You did 6 sprints and built incredible endurance!',
    },
    {
      time: 372,
      text: 'You are getting super fast and powerful! You are a speed champion!',
    },
    {
      time: 375,
      text: 'Great job, endurance champion! You are building incredible skills!',
    },
  ],
};
